module.exports = __webpack_public_path__ + "static/media/avatar_m.1047d704.jpeg";